<template>
    <div v-if="isCartOpen" class="cart-menu-div" style="background-color: #FFF;z-index: 9999;position: fixed;">
      <div class="cart-top-div">
        <div class="text-block-809">Your Cart</div>
        <a href="#" class="link-block-57 w-inline-block" @click.prevent="closeCart">
          <img src="@/assets/images/icon_Close.svg" loading="lazy" alt="Close">
        </a>
      </div>
  
      <div class="cart-wrap-div">
        <div class="cart-content">
          <div v-for="item in cartItems" :key="item.id" class="cart-entry-div">
            <div class="cart-image-div">
              <img :src="item.image" loading="lazy" :alt="item.name">
            </div>
  
            <div class="cart-entry-details">
              <div class="entry-top">
                <div class="product-name-wrap">
                  <div class="cart-product-name">{{ item.name }} </div>
                  <div class="cart-product-sub">{{ item.subheader }}</div>
                </div>
  
                <a href="#" class="link-block-58 w-inline-block" @click.prevent="removeItem(item.id)">
                  <img src="@/assets/images/icon_trash.svg" loading="lazy" alt="Remove">
                </a>
              </div>
  
              <div class="text-block-810">{{ item.type }}</div>
              <div class="text-block-811">Monthly</div>
  
              <div class="price-savings-div">
                <div class="current-old-price-div">
                  <div class="cart-current-price">${{ item.price }}</div>
                  <div class="cart-old-price">${{ item.retail_price }}</div>
                </div>
  
                <div class="units-div">
                  <div class="number-div">
                    <div class="text-block-813">{{ item.quantity }}</div>
                  </div>
  
                  <div class="unit-arrows-div">
                    <a href="#" class="link-block-59 w-inline-block" @click.prevent="updateQuantity(item.id, item.quantity + 1)">
                      <img src="@/assets/images/icon_increase.svg" loading="lazy" alt="Increase">
                    </a>
                    <a href="#" class="link-block-59 w-inline-block" @click.prevent="updateQuantity(item.id, item.quantity - 1)">
                      <img src="@/assets/images/icon_decrease.svg" loading="lazy" alt="Decrease">
                    </a>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <div class="cart-bottom">
          <div class="cart-summary-div">
            <div class="cart-discount-div">
              <div class="cart-discount-sum _1">Total Discount</div>
              <div class="cart-discount-sum _2">-${{ cartDiscount.toFixed(2) }}</div>
            </div>
  
            <div class="cart-subtotal-div">
              <div class="cart-subtotal">Subtotal</div>
              <div class="cart-subtotal _2">${{ cartTotal.toFixed(2) }}</div>
            </div>
  
            <div class="cart-shipping-div">
              <div class="cart-shipping-sum">Shipping</div>
              <div class="cart-shipping-sum _2">Free</div>
            </div>
  
            <div class="cart-button-div">
              <a href="#" class="button-82 w-button" @click.prevent="proceedToCheckout">PROCEED TO CHECKOUT</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapGetters, mapActions } from 'vuex'
  
  export default {
    name: 'ShoppingCart',
    computed: {
      ...mapGetters([
        'cartItems',
        'cartTotal',
        'cartDiscount',
        'isCartOpen'
      ])
    },
    methods: {
      ...mapActions([
        'removeFromCart',
        'updateCartQuantity',
        'setCartVisibility',
        'clearCart'
      ]),
      closeCart() {
        this.setCartVisibility(false);
      },
      removeItem(itemId) {
        this.removeFromCart(itemId);
      },
      updateQuantity(itemId, quantity) {
       
        this.updateCartQuantity({ itemId, quantity });
      },
      proceedToCheckout() {
        // Add your checkout logic here
        if (this.cartItems.length > 0) {
          this.setCartVisibility(false);
          this.$router.push('/payment');
        }
      }
    }
  }
  </script>